import { __decorate } from "tslib";
import { createContext } from "react";
import { action, makeObservable, observable } from "mobx";
export const TileApiInterfaceContext = createContext(null);
/**
 * An observable registry of tile API instances
 */
export class TileApiInterface {
    constructor() {
        Object.defineProperty(this, "tileApiMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map()
        });
        makeObservable(this);
    }
    register(id, tileApi) {
        this.tileApiMap.set(id, tileApi);
    }
    unregister(id) {
        this.tileApiMap.delete(id);
    }
    getTileApi(id) {
        return this.tileApiMap.get(id);
    }
    forEach(callback) {
        this.tileApiMap.forEach(api => callback(api));
    }
}
__decorate([
    action
], TileApiInterface.prototype, "register", null);
__decorate([
    action
], TileApiInterface.prototype, "unregister", null);
export const EditableTileApiInterfaceRefContext = createContext(null);
export const TileModelContext = createContext(null);
export const RegisterToolbarContext = createContext(null);
export const AddTilesContext = createContext(null);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlsZS1hcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90aWxlcy90aWxlLWFwaS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBRSxhQUFhLEVBQWdCLE1BQU0sT0FBTyxDQUFDO0FBQ3BELE9BQU8sRUFBRSxNQUFNLEVBQUUsY0FBYyxFQUFFLFVBQVUsRUFBRSxNQUFNLE1BQU0sQ0FBQztBQWdGMUQsTUFBTSxDQUFDLE1BQU0sdUJBQXVCLEdBQUcsYUFBYSxDQUEyQixJQUFJLENBQUMsQ0FBQztBQUVyRjs7R0FFRztBQUNILE1BQU0sT0FBTyxnQkFBZ0I7SUFHM0I7UUFGUTs7OzttQkFBYSxVQUFVLENBQUMsR0FBRyxFQUFvQjtXQUFDO1FBR3RELGNBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN2QixDQUFDO0lBR0QsUUFBUSxDQUFDLEVBQVUsRUFBRSxPQUFpQjtRQUNwQyxJQUFJLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxFQUFFLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDbkMsQ0FBQztJQUdELFVBQVUsQ0FBQyxFQUFVO1FBQ25CLElBQUksQ0FBQyxVQUFVLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQzdCLENBQUM7SUFFRCxVQUFVLENBQUMsRUFBVTtRQUNuQixPQUFPLElBQUksQ0FBQyxVQUFVLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBRSxDQUFDO0lBQ2xDLENBQUM7SUFFRCxPQUFPLENBQUMsUUFBaUM7UUFDdkMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztJQUNoRCxDQUFDO0NBQ0Y7QUFoQkM7SUFEQyxNQUFNO2dEQUdOO0FBR0Q7SUFEQyxNQUFNO2tEQUdOO0FBYUgsTUFBTSxDQUFDLE1BQU0sa0NBQWtDLEdBQUcsYUFBYSxDQUFxQyxJQUFJLENBQUMsQ0FBQztBQUUxRyxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxhQUFhLENBQW9CLElBQUksQ0FBQyxDQUFDO0FBS3ZFLE1BQU0sQ0FBQyxNQUFNLHNCQUFzQixHQUFHLGFBQWEsQ0FBaUMsSUFBSSxDQUFDLENBQUM7QUE0QjFGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxhQUFhLENBQTBCLElBQUksQ0FBQyxDQUFDIn0=